import * as THREE from 'three'

import terrainVertexShader from './shaders/terrain.vertex.glsl'
import terrainFragmentShader from './shaders/terrain.fragment.glsl'

export default class Terrain
{
    /**
     * Constructor
     */
    constructor(_options = {})
    {
        this.container = new THREE.Object3D()

        this.mobile = _options.mobile
        this.time = _options.time
        this.loader = _options.loader
        this.ui = _options.ui
        this.geometry = _options.geometry
        this.texture = _options.texture

        this.setPlane()
    }

    /**
     * Set plane
     */
    setPlane()
    {
        this.plane = {}

        // Elevation texture
        this.plane.terrainTexture = new THREE.Texture(this.texture)
        this.plane.terrainTexture.needsUpdate = true

        // Geometry
        this.plane.geometry = this.geometry

        // Material
        this.plane.material = new THREE.ShaderMaterial({
            wireframe: false,
            transparent: true,
            flatShading: true,
            depthTest: true,
            depthWrite: false,
            // depthWrite: false,
            // depthTest: false,
            blending: THREE.AdditiveBlending,
            uniforms:
            {
                uTerrainTexture: { value: this.plane.terrainTexture },
                uElevationNoiseMultiplier: { value: 0.07 },
                uElevationMultiplier: { value: 1 },

                uWaveDistance: { value: 2 },
                uWaveAmplitude: { value: 1 },
                uWaveStrength: { value: 0 },

                uDistortionProgress: { value: 0 },
                uDistortionStrength: { value: 1 },

                uColor: { value: new THREE.Vector3(0.12, 0.12, 0.12) },
                uFocusColor: { value: new THREE.Vector3(1, 0.9, 0) },

                uFocusPosition: { value: new THREE.Vector3(0, 0, -5) },
                uFocusDistance: { value: new THREE.Vector2(0, 1) },
                uFocusMultiplier: { value: 3 },

                uEdgeScaleMin: { value: 0 },
                uEdgeScale: { value: 1 },

                uFloatingFrequency: { value: 0.0001 },
                uFloatingAmplitude: { value: 0 },

                uAlpha: { value: 1 },

                uTime: { value: 0 }
            },
            vertexShader: terrainVertexShader,
            fragmentShader: terrainFragmentShader
        })

        // Mesh
        this.plane.mesh = new THREE.LineSegments(this.plane.geometry, this.plane.material)
        this.plane.mesh.rotation.x = - Math.PI * 0.5
        this.container.add(this.plane.mesh)

        // Time tick
        this.time.on('tick', () =>
        {
            this.plane.material.uniforms.uTime.value = this.time.elapsed
        })
    }

    /**
     * Reset
     */
    reset()
    {
        this.plane.material.uniforms.uElevationMultiplier.value = 0
        this.plane.material.uniforms.uEdgeScaleMin.value = 0.03
        this.plane.material.uniforms.uEdgeScale.value = 0
        this.plane.material.uniforms.uColor.value.x = 0
        this.plane.material.uniforms.uColor.value.y = 0
        this.plane.material.uniforms.uColor.value.z = 0
        this.plane.material.uniforms.uFocusColor.value.x = 1
        this.plane.material.uniforms.uFocusColor.value.y = 0.9
        this.plane.material.uniforms.uFocusColor.value.z = 0
        this.plane.material.uniforms.uWaveAmplitude.value = 10
        this.plane.material.uniforms.uDistortionProgress.value = 1
        this.plane.material.uniforms.uDistortionStrength.value = 0.35
        this.plane.material.uniforms.uFocusDistance.value.y = 0.75
        this.plane.material.uniforms.uFocusPosition.value.x = 0.3
        this.plane.material.uniforms.uFocusPosition.value.y = 0
        this.plane.material.uniforms.uFocusPosition.value.z = - 5.2
        this.plane.material.uniforms.uFloatingFrequency.value = 0.0001
        this.plane.material.uniforms.uFloatingAmplitude.value = 0.8
    }
}



// WEBPACK FOOTER //
// ./src/components/app-experience/Experience/Terrain.js